import localScaleManager from "../../../helpers/LocalScaleManager";
import { Pots } from "./pots/pots";
import { Cards } from "./cards/cards";
import { SeatManager } from "./seats/seatManager";
import { ButtonManager } from "../buttons/buttonManager";
import MessageBox from "./messageBox";
import { TableSounds } from "./tableSounds";
import ModalsManager from "../../modals/modalsManager";
import { WebSocketManager } from "../../../helpers/webSocketManager";
import { TableTimer } from "./tableTimer";
import { BestHand } from "./bestHand";
import TableLoading from "./tableLoading";
import { ShowHandMenu } from "./showHandMenu";
import { store } from "@/store/store";
import { DealerChip } from "./seats/dealerChip";
import { SeatTimer } from "./seatTimer";
import { SeatTurnGlow } from "./seatTurnGlow";

export default class Table extends Phaser.GameObjects.Image {
  /**
   * @param scene {GameScene}
   * @param tableNumber {number}
   * @param tableInfo
   * @param tableWallet
   */
  constructor(scene, tableNumber, tableInfo, tableWallet) {
    super(scene, 0, 0, "table");
    this.tableNumber = tableNumber;
    this.scene = scene;
    this.tableInfo = tableInfo;
    this.tableWallet = tableWallet;
    this.tableX = 0;
    this.poolArray = [];
    this.removed = false;

    // this.tableInfo.numberOfSeats = 10;
    this.setOrigin(0);
    this.scene.add.existing(this);
    this.poolArray.push(this);
    this.dealer = new DealerChip(scene, this);
    this.turnTimer = new SeatTimer(scene, this);
    this.seatTurnGlow = new SeatTurnGlow(scene, this);
    this.sounds = new TableSounds(scene, this);
    this.seatManager = new SeatManager(this.scene, this);
    this.seats = [];
    this._playerSeats = [];

    this.overlayHitArea = new Phaser.Geom.Rectangle(0, 0, 0, 0);
    this.poolArray.push(this.overlayHitArea);

    this.overlay = this.scene.add
      .rectangle(0, 0, 0, 0, 0x000000)
      .setAlpha(0.01)
      .setVisible(false)
      .setOrigin(0)
      .setDepth(90);
    this.poolArray.push(this.overlay);

    this.tableManager(this.tableInfo);

    this.pots = new Pots(scene, 0, this);
    this.cards = new Cards(scene, this, 0);
    if (tableInfo.reDealType.length !== 0) {
      this.cards2 = new Cards(scene, this, 1);
      this.cards3 = new Cards(scene, this, 2);
    }
    this.previousPlayerInTurn = -1;
    this.previousSelfPlayer = -1;
    // this.reserveModal = new ReservingModal(this.scene, this, tableInfo, 999000000)
    this.buttonManager = new ButtonManager(this.scene, this);
    this.messageBox = new MessageBox(this.scene, this);
    this.bestHand = new BestHand(this.scene, this);
    this.modalsManager = new ModalsManager(this.scene, this);
    this.loading = new TableLoading(this.scene, this);
    this.showHandMenu = new ShowHandMenu(this.scene, this, this.cardsType);

    this.scene.registry.set("tableWidth", this.displayWidth);
    this.gameState = {};

    this.tableInfoTxtInitValue = "".padStart(30, "a");
    this.tableInfoTxt = this.scene.add
      .bitmapText(0, 0, "HelveticaNeue", this.tableInfoTxtInitValue)
      .setVisible(false)
      .setAlpha(0.4);
    this.poolArray.push(this.tableInfoTxt);

    this.tableInfoTxt.setData("width", this.tableInfoTxt.width);
    this.tableInfoTxt.setData("height", this.tableInfoTxt.height);

    this.gameInfoTxt = this.scene.add
      .bitmapText(0, 0, "HelveticaNeue", this.tableInfoTxtInitValue)
      .setVisible(false)
      // .setAlpha(0.25);
      .setAlpha(0.4);
    this.poolArray.push(this.gameInfoTxt);

    this.gameInfoTxt.setData("width", this.gameInfoTxt.width);
    this.gameInfoTxt.setData("height", this.gameInfoTxt.height);

    // this.selfPlayerGlow = this.scene.add
    //   .image(0, 0, this.scene.atlasTexture, "self-player-box")
    //   .setOrigin(0.5);
    // this.poolArray.push(this.selfPlayerGlow);

    this.tableTimer = new TableTimer(scene, this);
    this.gameId = 0;
    this.askReadealAlert = null;
    this.askReadealConfirmationAlert = null;
    this.firstGameState = null;
  }
  get playerSeats() {
    this._playerSeats = this.seats.filter((seat) => seat.playerId);
    return this._playerSeats;
  }

  tableManager(tableInfo) {
    // tableInfo.numberOfSeats = 4;
    // tableInfo.tableType = "PLO5";
    const seatConfigurations = {
      2: ["cb", "ct"],
      3: ["cb", "lt1", "rt1"],
      4: ["cb", "lt1", "ct", "rt1"],
      5: ["cb", "lb1", "lt2", "rt2", "rb1"],
      6: ["cb", "lb1", "lt2", "ct", "rt2", "rb1"],
      7: ["cb", "lb2", "lt1", "ct", "rt2", "rt1", "rb2"],
      8: ["cb", "lb2", "lt1", "lt2", "ct", "rt2", "rt1", "rb1"],
      9: ["cb", "lb2", "lt1", "lt2", "ct", "rt2", "rt1", "rb1", "rb2"],
      10: ["cb", "lb2", "lb1", "lt1", "lt2", "ct", "rt2", "rt1", "rb1", "rb2"],
    };

    this.cardsType = this.getCardsType(tableInfo.tableType);

    if (seatConfigurations[tableInfo.numberOfSeats]) {
      this.seats = seatConfigurations[tableInfo.numberOfSeats].map(
        (position, index) => {
          return this.seatManager.createSeat(
            position,
            index + 1,
            false,
            true,
            this.cardsType
          );
        }
      );
    }
  }

  getCardsType(tableType) {
    return (
      {
        PLO4: "4-cardDeck",
        PLO5: "5-cardDeck",
        NLH: "2-cardDeck",
      }[tableType] || "2-cardDeck"
    );
  }

  async handleGameState(state, isPulled) {
    if (!this.scene.positionsWereControlled) return;

    this.firstGameState = this.firstGameState === null;
    this.manageAudio(isPulled);

    this.gameState = state;
    this.updateGameInfoText();
    this.initializePreviousPlayer(state);
    this.updateSeats(state);
    await this.handleSelfPlayer(state, this.isTableVisiting());
    this.seatManager.checkActionsStatus(this.seats, state.state);
    this.updateDealerPosition(state);
    this.deactivateSeats(state);

    this.stateManager(state);
    this.tableTimer.handleGameState(state);

    if (!(state.state === "PreFlop" && state.newState)) {
      this.buttonManager.handleGameState(state);
    }

    this.pots.handleGameState(state);
    this.handleModals();
    this.handleReDealModal();
    this.handleBuyInMenuBtn();

    this.previousPlayerInTurn = state.playerInTurn;
  }

  manageAudio(isPulled) {
    if (!isPulled && !this.firstGameState) {
      this.sounds.unmuteAll();
    } else if (isPulled) {
      this.sounds.muteAllExcept(["timer"]);
    }
  }

  initializePreviousPlayer(state) {
    if (this.previousPlayerInTurn === -1) {
      this.previousPlayerInTurn = state.playerInTurn;
    }
  }

  updateSeats(state) {
    for (let i = 0; i < this.seats.length; i++) {
      const seat = this.seats[i];
      const seatPlayerInfo = state.otherPlayers.find(
        (player) => player.position === seat.serverPosition
      );
      if (seatPlayerInfo) {
        seat.updatePlayerInfo(seatPlayerInfo, state);
      } else if (
        state.playerInfo &&
        state.playerInfo.position === seat.serverPosition
      ) {
        // Seat is occupied by the current player
      } else {
        seat.empty();
      }
    }
  }

  async handleSelfPlayer(state, isTableVisiting) {
    if (state.playerInfo) {
      /* If the self-player has already sat*/
      await this.processSeatedPlayer(state, isTableVisiting);
    } else {
      await this.processUnseatedPlayer();
    }
  }

  async processSeatedPlayer(state, isTableVisiting) {
    if (
      state.playerInfo.id === state.playerInTurn &&
      state.playerInfo.autoAction === "None"
    ) {
      this.scene.manageAutoSwitchTables(this.tableInfo.id);
    }

    if (!this.seatManager.hasSelfPlayerSat()) {
      /* The first game state that the self-player joined the table */
      store.commit("setAddMoreChipsClosedByUser", false);
      await this.repositionSeats(state.playerInfo.position, true);
      this.markSelfPlayerSeat(state);
      this.updateSelfPlayerInfo(state);
    } else {
      await this.updateSelfPlayerPosition(state);
    }
  }

  async processUnseatedPlayer() {
    /* If the self-player has not sat yet*/
    if (this.showHandMenu) this.showHandMenu.hide();

    if (this.seatManager.hasSelfPlayerSat()) {
      /* The first game state that the self-player left the table */
      this.resetSeats();
      await this.repositionSeats(1, true);
      this.updateSeatPositions();
    }
  }

  async repositionSeats(position, immediate) {
    try {
      await this.seatManager.changeSeatsPositionsBy(
        this.seatManager.getPositionByServerPosition(position),
        immediate
      );
    } catch (e) {
      console.error(e);
    }
  }

  markSelfPlayerSeat(state) {
    this.seatManager.getSeatByServerPosition(
      state.playerInfo.position
    ).isMyTable = true;
    /* For changing seats when the self-player sat. */
    this.seats.forEach((seat) => {
      this.seatManager.positionControls(seat, false);
    });
  }

  updateSelfPlayerInfo(state) {
    this.seatManager
      .getSeatByServerPosition(state.playerInfo.position)
      .updateSelfPlayer(state.playerInfo, state);
  }

  async updateSelfPlayerPosition(state) {
    const selfPlayerSeat = this.seatManager.getSelfPlayerSeat();
    if (selfPlayerSeat.serverPosition !== state.playerInfo.position) {
      // If the self-player has already sat but its position changed.
      await this.repositionSeats(state.playerInfo.position, false);
      selfPlayerSeat.isMyTable = false;
      this.markSelfPlayerSeat();
      this.updateSelfPlayerInfo(state);
    } else {
      this.updateSelfPlayerInfo(state);
    }
  }

  resetSeats() {
    this.seats.forEach((seat) => (seat.isMyTable = false));
    this.bestHand.hide();
  }

  updateSeatPositions() {
    this.seats.forEach((seat) => {
      this.seatManager.positionControls(seat, false);
    });
  }

  updateDealerPosition(state) {
    const dealerSeat = this.seatManager.getSeatByServerPosition(
      state.dealerPosition
    );
    this.dealer.setPosition(dealerSeat.dealerX, dealerSeat.dealerY);
    if (!this.dealer.visible) {
      this.dealer.setVisible(true);
    }
  }

  deactivateSeats(state) {
    this.seats.forEach((seat) => {
      if (seat.playerId !== state.playerInTurn) seat.deactivate();
    });
  }

  async stateManager(gameState) {
    const ignoredStates = ["PreEnd", "PreMerge", "Merge", "AddOnBreak", "AddOnPhase"];
    if(ignoredStates.includes(gameState.state)) return;
    
    const stateHandlers = {
      Idle: async () => {
        this.cardsIdleState();
        this.playerSeats.forEach((seat) => {
          if (seat.playerInfo.state !== "SitOut") seat.setDisable(false);
          seat.compeleteWin();
        });
        this.pots.centerPot.visibilityControls(true);
        this.specifyPlayerInTurn(gameState.playerInTurn);
      },
      Straddle: async () => {
        await this.showBlindsChips();
      },
      PreFlop: async () => {
        let seatsDelay = null;
        if (gameState.newState) {
          if (this.gameState.straddlePlayer) {
            const straddleSeat = this.findSeatByUserId(
              this.gameState.straddlePlayer
            );
            if (straddleSeat && straddleSeat.playerInfo.bet) {
              seatsDelay = 100;
              await straddleSeat.playerBet.updatePlayerBet(
                straddleSeat.playerInfo
              );
              this.sounds.play("bet");
            }
          } else {
            await this.showBlindsChips();
            seatsDelay = 200;
          }
          /* The following line is intended for cases where a new game state is reached before the tweens for displaying chips have completed.*/
          if (!(this.gameState.state === "PreFlop" && this.gameState.newState))
            return;
          this.playerSeats.forEach((seat) => {
            if (
              !["SmallBlind", "BigBlind", "Straddle"].includes(
                seat.playerInfo.role
              )
            ) {
              seat.playerBet.updatePlayerBet(seat.playerInfo, seatsDelay);
            }
          });
          for (let seat of this.playerSeats) {
            seat.cards.visibilityControls(false);
          }
          await this.findSeatByPosition(
            gameState.dealerPosition
          ).dealingCardsToPlayers(this.playerSeats);
          this.specifyPlayerInTurn(this.gameState.playerInTurn, 100);
          this.buttonManager.handleGameState(this.gameState);
          if (this.seatManager.hasSelfPlayerSat()) {
            const selfSeat = this.seatManager.getSeatByPosition("cb");
            selfSeat.cards.showHand(selfSeat.playerInfo.hand);
          }
        } else {
          this.specifyPlayerInTurn(gameState.playerInTurn);
        }
      },
      Flop: async () => {
        if (gameState.newState || !this.cards.areFlopCardsShown) {
          await this.showFlopCards(
            gameState.tableCardsList,
            gameState.newState
          );
          if (gameState.playerInfo?.bestHand) {
            this.bestHand.show(gameState.playerInfo.bestHand.type);
          }
          this.specifyPlayerInTurn(gameState.playerInTurn, 100);
        } else {
          this.specifyPlayerInTurn(gameState.playerInTurn);
        }
      },
      Turn: async () => {
        if (gameState.newState || !this.cards.isTurnCardShown) {
          if (!this.cards.areFlopCardsShown) {
            await this.showFlopCards(gameState.tableCardsList, false);
          }
          await this.showTurnCard(gameState.tableCardsList, gameState.newState);
          if (gameState.playerInfo?.bestHand) {
            this.bestHand.show(gameState.playerInfo.bestHand.type);
          }
          this.specifyPlayerInTurn(gameState.playerInTurn, 100);
        } else {
          this.specifyPlayerInTurn(gameState.playerInTurn);
        }
      },
      River: async () => {
        if (gameState.newState || !this.cards.isRiverCardShown) {
          if (!this.cards.areFlopCardsShown) {
            await this.showFlopCards(gameState.tableCardsList, false);
          }
          if (!this.cards.isTurnCardShown) {
            await this.showTurnCard(gameState.tableCardsList, false);
          }
          await this.showRiverCard(
            gameState.tableCardsList,
            gameState.newState
          );
          if (gameState.playerInfo?.bestHand) {
            this.bestHand.show(gameState.playerInfo.bestHand.type);
          }
          this.specifyPlayerInTurn(gameState.playerInTurn, 100);
        } else {
          this.specifyPlayerInTurn(gameState.playerInTurn);
        }
      },
      End: async () => {
        this.specifyPlayerInTurn(gameState.playerInTurn);
        if (gameState.newState) {
          this.playerSeats.forEach((seat) => {
            if (
              !["Fold", "SitOut", "WaitToJoin", "WaitToStart"].includes(
                seat.playerInfo.state
              )
            ) {
              seat.cards.showHand(seat.playerInfo.hand);
            }
          });
          this.pots.winPotChips(gameState.sidePotRoundInfos);
        }
        if (!this.cards.isRiverCardShown) {
          if (!this.cards.areFlopCardsShown) {
            await this.showFlopCards(gameState.tableCardsList, false);
          }
          if (!this.cards.isTurnCardShown) {
            await this.showTurnCard(gameState.tableCardsList, false);
          }
          await this.showRiverCard(
            gameState.tableCardsList,
            false
          );
        }
        if (
          gameState.playerInfo?.rabbitActive &&
          gameState.rabbitCardsCount > 0
        ) {
          this.cards.showRabbitCard();
        }
        if (gameState.src === "rabbit-show") {
          this.cards.showCardsByRabbit(gameState);
        }
      },
      default: async () => {
        console.warn(`Unhandled game state: ${gameState.state}`);
      },
    };

    const handler = stateHandlers[gameState.state] || stateHandlers.default;
    await handler();
  }

  async showBlindsChips() {
    let sBSeat,
      bBSeat,
      otherSeats = [];
    const gameState = this.gameState;
    if (gameState.newState) {
      this.playerSeats.forEach((seat) => {
        switch (seat.playerInfo.role) {
          case "SmallBlind": {
            sBSeat = seat;
            break;
          }
          case "BigBlind": {
            bBSeat = seat;
            break;
          }
          default: {
            otherSeats.push(seat);
          }
        }
      });
      // FIXME: TypeError: Cannot read properties of undefined (reading 'playerBet')
      this.sounds.play("bet");
      await sBSeat.playerBet.updatePlayerBet(sBSeat.playerInfo);
      await bBSeat.playerBet.updatePlayerBet(bBSeat.playerInfo, 100);
      this.sounds.play("call");
    }
  }
  handleMessages(msg) {
    const seat = this.playerSeats.find((seat) => +seat.playerId === msg.userId);
    if (seat) seat.messageBox.showText(msg.chat);
  }
  cardsIdleState() {
    this.cards.idleState();
    if (this.isRedealTable()) {
      this.cards2.idleState();
      this.cards3.idleState();
    }
  }
  async showFlopCards(cards, setDelay) {
    if (!this.cards.areFlopCardsShown) {
      await this.cards.showFlopCards(cards[0], setDelay);
    } else if (this.isRedealTable()) {
      if (!this.cards2.areFlopCardsShown) {
        if (cards[1]) this.cards2.showFlopCards(cards[1], true);
      } else {
        if (cards[2]) this.cards3.showFlopCards(cards[2], true);
      }
    }
  }
  async showRiverCard(cards) {
    if (!this.cards.isRiverCardShown) {
      await this.cards.showRiverCard(cards[0]);
    } else if (this.isRedealTable()) {
      if (!this.cards2.isRiverCardShown) {
        if (cards[1]) this.cards2.showRiverCard(cards[1]);
      } else {
        if (cards[2]) this.cards3.showRiverCard(cards[2]);
      }
    }
  }
  async showTurnCard(cards) {
    if (!this.cards.isTurnCardShown) {
      await this.cards.showTurnCard(cards[0]);
    } else if (this.isRedealTable()) {
      if (!this.cards2.isTurnCardShown) {
        if (cards[1]) this.cards2.showTurnCard(cards[1]);
      } else {
        if (cards[2]) this.cards3.showTurnCard(cards[2]);
      }
    }
  }
  findSeatByUserId(id) {
    return this.seats.find((seat) => seat.playerId === id);
  }
  findSeatByPosition(position) {
    return this.seats.find((seat) => seat.playerInfo.position === position);
  }
  isPlayerTurnOver(player) {
    return player ? this.previousPlayerInTurn !== player : false;
  }
  isYourSelfPlayerTurn() {
    return (
      this.gameState.playerInfo &&
      this.gameState.playerInfo.id === this.gameState.playerInTurn
    );
  }
  isTournamentTable() {
    return false;
  }
  handleReDealModal() {
    let state = this.gameState;
    this.scene.alertify.dismissAll();
    if (this.askReadealConfirmationAlert) {
      // this.askReadealConfirmationAlert.clear();
      this.scene.alertify.dismissAll();
      this.askReadealConfirmationAlert = null;
    }
    if (this.askReadealAlert) {
      // this.askReadealAlert.clear();
      this.scene.alertify.dismissAll();
      this.askReadealAlert = null;
    }
    // if (!state.playerInfo) return;
    if (this.isTableVisiting()) {
      if (state.askRedeal) {
        // if(state.src !== "redeal type ask") return;
        if (state.playerInfo && state.playerInTurn === state.playerInfo.id) {
          this.modalsManager.reDealModal.show(true);
          this.modalsManager.reDealModal.updateInfo(state, true);
        } else if (state.playerInTurn && !this.askReadealAlert) {
          this.askReadealAlert = this.scene.alertify.tableAlert(
            "Requesting running it multi-times"
          );
        }
      }
      if (state.redealConfirmation) {
        if (state.playerInfo && state.playerInTurn === state.playerInfo.id) {
          this.modalsManager.reDealModal.show(false);
          this.modalsManager.reDealModal.updateInfo(state, false);
        } else if (state.playerInTurn && !this.askReadealConfirmationAlert) {
          this.askReadealConfirmationAlert = this.scene.alertify.tableAlert(
            "Waiting for approval..."
          );
        }
      }
      if (!state.askRedeal && !state.redealConfirmation) {
        this.modalsManager.reDealModal.hide();
      }
    }
  }
  handleModals() {
    this.handleBuyInMenuBtn();
    const isTableVisiting = this.isTableVisiting();
    const addMoreChipModal = this.scene.addMoreChipModal;
    const reserveModal = this.scene.reserveModal;
    if (this.gameState.playerInfo && isTableVisiting) {
      if (this.tableInfo.id !== addMoreChipModal.table.tableInfo.id) {
        addMoreChipModal.hide();
      }
      if (this.gameState.playerInfo.joinMode === "Reserved") {
        reserveModal.show(this, this.gameState.playerInfo);
        // reserveModal.show(this, state.playerInfo, false)handleModals
      } else if (
        ["OnBB", "NextHand", "AfterButton", "Joined"].includes(
          this.gameState.playerInfo.joinMode
        ) ||
        this.gameState.playerInfo.state === "WaitToStart"
      ) {
        reserveModal.hide();
      }

      if (
        this.tableInfo.isReBuyEnabled &&
        this.gameState.playerInfo.state === "SitOut" &&
        this.gameState.playerInfo.balance === 0 &&
        // !addMoreChipModal.isShowing &&
        // !addMoreChipModal.userClosedModal
        !store.getters.getAddMoreChipsClosedByUser
      ) {
        addMoreChipModal.show(this, true);
      } else if (addMoreChipModal.autoShow) {
        addMoreChipModal.hide();
      }
    } else if (isTableVisiting) {
      if (this.tableInfo.id !== addMoreChipModal.table.tableInfo.id) {
        addMoreChipModal.hide();
      }
      if (this.tableInfo.id !== reserveModal.table.tableInfo.id) {
        reserveModal.hide();
      }
      // reserveModal.hide();
      // addMoreChipModal.hide();
    }
  }
  handleBuyInMenuBtn() {
    const buyInMenuBtn = this.scene.header.buyInMenu.button;
    const isTableVisiting = this.isTableVisiting();
    if (!isTableVisiting) return;
    if (this.gameState.playerInfo && !this.isTournamentTable()) {
      if (!buyInMenuBtn.visible) buyInMenuBtn.setVisible(true);
    } else {
      if (buyInMenuBtn.visible) buyInMenuBtn.setVisible(false);
    }
    let chatIcon = this.scene.chat.chatIcon;
    if (this.tableInfo.chatEnabled) {
      if (!chatIcon.visible) chatIcon.setVisible(true);
    } else {
      if (chatIcon.visible) chatIcon.setVisible(false);
    }
  }
  handleRedealRejection(msg) {
    if (this.tableInfo.id !== this.scene.getVisitedTable().tableInfo.id) return;
    this.scene.alertify.dismissAll();
    this.scene.alertify.tableInfoAlert(msg, 3000);
  }
  hideTournamentModals() {
    if (!this.isTableVisiting() || !this.scene.hasTournamentTable()) return;

    /* Hide Tournament Rebuy Modal */
    if (this.scene.registry.get("showTournamentRebuy"))
      this.scene.registry.set("showTournamentRebuy", false);

    /* Hide Tournament Result Modal */
    if (this.scene.registry.get("showTournamentResult"))
      this.scene.registry.set("showTournamentResult", false);

    /* Hide Tournament Add On Modal */
    const oldVal = store.getters.getTournamentAddOnInfo;
    if (oldVal.show) {
      const info = {
        show: false,
        addOnBreak: false,
        clubId: "",
        closedByUser: false,
      };
      store.commit("setTournamentAddOnInfo", info);
    }
  }
  async pullGameState() {
    return new Promise((resolve, reject) => {
      WebSocketManager.emitEvent(
        { tableId: this.tableInfo.id },
        "poker.client-pull.game-state"
      )
        .then((res) => {
          if (!res.deleted) {
            // this.firstGameState = null;
            this.gameState = res;
            this.handleGameState(res, true);
            resolve();
          } else {
            this.scene.tableExpired(this.tableInfo.id);
            reject();
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  }
  handleVisibilityChange(hidden) {
    if (!hidden) this.pullGameState();
    this.seats.forEach((seat) => seat.handleVisibilityChange(hidden));
    this.pots.handleVisibilityChange(hidden);
    this.cards.handleVisibilityChange(hidden);
  }
  completeTweens() {
    let activeTweens = this.scene.tweens.getTweensOf([...this.poolArray]);
    activeTweens.forEach((tween) => {
      if (tween.isTimeline) {
        tween.data.forEach((timeLineTween) => {
          if (timeLineTween.complete) timeLineTween.complete();
        });
      } else tween.complete();
    });
  }
  updateTableInfoText() {
    const smallBlind = this.tableInfo.smallBlinds
      ? this.tableInfo.smallBlinds.toLocaleString()
      : "0";
    const bigBlind = this.tableInfo.bigBlinds
      ? this.tableInfo.bigBlinds.toLocaleString()
      : "0";
    const ante = this.tableInfo.ante
      ? this.tableInfo.ante.toLocaleString()
      : "0";
    let firstTxt = +ante
      ? `Blinds: ${smallBlind}/${bigBlind}  Ante: ${ante}`
      : `Blinds: ${smallBlind}/${bigBlind}`;
    this.tableInfoTxt.setText(firstTxt);
    this.tableInfoTxt.setX(
      this.x + (this.displayWidth - this.tableInfoTxt.width) / 2
    );
    if (!this.tableInfoTxt.visible) this.tableInfoTxt.setVisible(true);
  }
  updateGameInfoText() {
    if (this.gameId !== this.gameState.gameId) {
      this.gameInfoTxt.setText(
        `ID: ${this.gameState.gameId ? this.gameState.gameId : "_"}   ${
          this.tableInfo.name
        }`
      );
      this.gameInfoTxt.setX(
        this.x + (this.displayWidth - this.gameInfoTxt.width) / 2
      );
      if (!this.gameInfoTxt.visible) this.gameInfoTxt.setVisible(true);
      this.gameId = this.gameState.gameId;
    }
  }
  setIdle() {
    this.seats.forEach((seat) => {
      seat.setIdle();
    });
    this.cardsIdleState();
  }
  async unseatSelfPlayer() {
    this.seats.forEach((seat) => {
      seat.isMyTable = false;
    });
    this.bestHand.hide();
  }

  onStraddleStateReceived(state) {
    if (
      this.gameState.playerInfo &&
      this.gameState.playerInfo.id === state.straddlePlayer
    ) {
      const straddleBtns = this.buttonManager.straddleBtns;
      this.buttonManager.hideAllButtons();
      straddleBtns.show(this.gameState.playerInfo.timeRemaining);
    } else if (this.isTableVisiting()) {
      this.scene.alertify.tableAlert("Waiting for straddle...");
    }
  }
  specifyPlayerInTurn(playerInTurn, delay) {
    if (!playerInTurn) return;
    // console.log(delay);
    this.seats.forEach((seat) => {
      if (seat.playerId === playerInTurn) {
        if (this.gameState.src === "UseTimeBank") seat.deactivate();
        seat.activate(this.previousPlayerInTurn === playerInTurn);
      } else if (seat.playerId) seat.deactivate();
    });
  }
  isTableVisiting() {
    return this.tableInfo.id === this.scene.getVisitedTable().tableInfo.id;
  }
  isRedealTable() {
    return this.tableInfo.reDealType.length !== 0;
  }
  offOverlayEvents() {
    this.overlay.off("pointerup");
    this.overlay.off("pointerout");
    this.overlay.off("pointerdown");
  }
  /**
   * @param {number} width
   * @param {number} height
   */
  positionControls(width, height) {
    localScaleManager.scaleSprite(this, width, height, 0, 1, false);
    this.tableX =
      (this.tableNumber - 1) * width + (width - this.displayWidth) / 2;
    this.setPosition(this.tableX, (height - this.displayHeight) / 2);
    this.scene.registry.set("tableWidth", this.displayWidth);
    this.seats.forEach((seat) => {
      this.seatManager.positionControls(seat, false);
    });
    this.seatManager.setPositionsList();
    this.pots.positionControls(
      this.displayWidth,
      this.displayHeight,
      this.tableX,
      this.y
    );
    this.cards.positionControls(
      this.displayWidth,
      this.displayHeight,
      this.tableX,
      this.y
    );
    if (this.isRedealTable()) {
      this.cards2.positionControls(
        this.displayWidth,
        this.displayHeight,
        this.tableX,
        this.y
      );
      this.cards3.positionControls(
        this.displayWidth,
        this.displayHeight,
        this.tableX,
        this.y
      );
    }
    this.showHandMenu.positionControls(
      this.displayWidth,
      this.displayHeight,
      this.tableX,
      this.y
    );
    // this.cards.visibilityControls(true);
    // this.cards2.visibilityControls(true);
    // this.cards3.visibilityControls(true);
    this.buttonManager.positionControls(
      this.x,
      this.y,
      this.displayWidth,
      this.displayHeight
    );
    this.messageBox.positionControls(
      this.x,
      this.y,
      this.displayWidth,
      this.displayHeight
    );
    this.bestHand.positionControls(
      this.x,
      this.y,
      this.displayWidth,
      this.displayHeight
    );

    this.modalsManager.positionControls(
      this.displayWidth,
      this.displayHeight,
      this.x,
      this.y
    );

    this.tableInfoTxtSize = this.displayWidth / 1.8;
    localScaleManager.scaleBitMapText(
      this.tableInfoTxt,
      this.displayWidth,
      this.displayHeight * 0.015,
      0,
      1,
      false
    );
    this.tableInfoTxt.setPosition(
      this.x + (this.displayWidth - this.tableInfoTxt.width) / 2,
      this.y + this.displayHeight * 0.645
    );
    this.updateTableInfoText();

    this.gameInfoTxtSize = this.displayWidth / 2;
    localScaleManager.scaleBitMapText(
      this.gameInfoTxt,
      this.displayWidth,
      this.displayHeight * 0.015,
      0,
      1,
      false
    );
    this.gameInfoTxt.setPosition(
      this.x + (this.displayWidth - this.gameInfoTxt.width) / 2,
      this.y + this.displayHeight * 0.662
    );
    this.updateGameInfoText();

    this.tableTimer.positionControls(
      this.displayWidth,
      this.displayHeight,
      this.x,
      this.y
    );
    this.loading.positionControls(
      this.tableNumber - 1,
      this.displayWidth,
      this.displayHeight,
      this.x,
      this.y
    );
    this.overlayHitArea.width = this.scene.gameWidth;
    this.overlayHitArea.height = this.scene.gameHeight;
    this.overlay.width = this.scene.gameWidth;
    this.overlay.height = this.scene.gameHeight;
    this.overlay.setPosition(this.scene.gameWidth * (this.tableNumber - 1), 0);
    this.overlay.setInteractive(
      this.overlayHitArea,
      Phaser.Geom.Rectangle.Contains
    );
    this.dealer.positionControls(this.displayWidth * 0.04, 0, 0);
    this.turnTimer.positionControls(this.displayWidth * 0.04, 0, 0);
  }
  /**
   * @param {number} width
   * @param {number} height
   */
  reposition(width, height) {
    this.tableX =
      (this.tableNumber - 1) * width + (width - this.displayWidth) / 2;
    this.setPosition(this.tableX, (height - this.displayHeight) / 2);
    this.seats.forEach((seat) => {
      this.seatManager.positionControls(seat, true);
    });
    this.seatManager.setPositionsList();
    this.pots.reposition(
      this.displayWidth,
      this.displayHeight,
      this.tableX,
      this.y
    );
    this.cards.reposition(
      this.displayWidth,
      this.displayHeight,
      this.tableX,
      this.y
    );
    if (this.isRedealTable()) {
      this.cards2.reposition(
        this.displayWidth,
        this.displayHeight,
        this.tableX,
        this.y
      );
      this.cards3.reposition(
        this.displayWidth,
        this.displayHeight,
        this.tableX,
        this.y
      );
    }
    this.showHandMenu.reposition(
      this.displayWidth,
      this.displayHeight,
      this.tableX,
      this.y
    );
    // this.cards.visibilityControls(true);
    // this.cards2.visibilityControls(true);
    // this.cards3.visibilityControls(true);
    this.buttonManager.reposition(
      this.x,
      this.y,
      this.displayWidth,
      this.displayHeight
    );
    this.messageBox.reposition(
      this.x,
      this.y,
      this.displayWidth,
      this.displayHeight
    );
    this.bestHand.reposition(
      this.x,
      this.y,
      this.displayWidth,
      this.displayHeight
    );

    this.modalsManager.reposition(
      this.displayWidth,
      this.displayHeight,
      this.x,
      this.y
    );
    this.tableInfoTxt.setPosition(
      this.x + (this.displayWidth - this.tableInfoTxt.width) / 2,
      this.y + this.displayHeight * 0.645
    );
    this.updateTableInfoText();

    this.gameInfoTxt.setPosition(
      this.x + (this.displayWidth - this.gameInfoTxt.width) / 2,
      this.y + this.displayHeight * 0.662
    );
    this.updateGameInfoText();

    this.tableTimer.reposition(
      this.displayWidth,
      this.displayHeight,
      this.x,
      this.y
    );
    this.loading.reposition(
      this.tableNumber - 1,
      this.displayWidth,
      this.displayHeight,
      this.x,
      this.y
    );
    this.overlay.setPosition(this.scene.gameWidth * (this.tableNumber - 1), 0);
    this.overlay.setInteractive(
      this.overlayHitArea,
      Phaser.Geom.Rectangle.Contains
    );
    this.turnTimer.reposition(this.displayWidth * 0.04, 0, 0);
  }
  remove() {
    this.removed = true;
    this.sounds.remove();
    this.seats.forEach((seat) => seat.remove());
    this.destroy();
    this.tableInfoTxt.destroy();
    this.gameInfoTxt.destroy();
  }
}
